@if (parentCustomOutcomeIdControl && availableParents) {
  <div class="custom-parent-selection-panel-container" >
    <div class="row">
      <div class="col-md-12">
        <mat-radio-group [formControl]="parentCustomOutcomeIdControl">
          <mat-radio-button class="parent-outcome-radio-button" name="parent" [value]="null" color="primary">Not Linked to a Strategy Outcome</mat-radio-button>
          <hr />
          @if (availableParents.length) {
            <div>
              <div class="mb-2">
                <strong>Related Strategies and their Custom Outcomes</strong>
              </div>
              @for (availableParent of availableParents; track availableParent) {
                <div>
                  <h4 class="text-success">
                    <strong>{{availableParent.strategyName}}</strong>
                    ({{availableParent.strategyType}})
                    <span class="text-muted" style="font-size: 11pt;">{{availableParent.relationShipType}}</span>
                  </h4>
                  @for (projectOutcome of availableParent.projectOutcomes; track projectOutcome) {
                    <mat-radio-button class="parent-outcome-radio-button"
                      name="parent" color="primary" [value]="projectOutcome.customOutcome.customOutcomeId">
                      <strong>{{projectOutcome.customOutcome.indicatorName}}</strong> ({{projectOutcome.customOutcome.indicatorName}})<br>
                      <span class="text-muted">{{projectOutcome.statement}}</span>
                    </mat-radio-button>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="no-relations">
              <div class="alert alert-info alert-styled-left shadow-0 mr-3 ng-star-inserted" style="margin-top: 10px;">
                You currently do not have any Related Strategies and/or your Related Strategies have no Outcomes of the same type as yours.
              </div>
            </div>
          }
        </mat-radio-group>
      </div>
    </div>
  </div>
}
